module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-02-ef697d93559d67e000900ae163fb957d.jpg";